import React from "react";
import { Bar } from "@ant-design/plots";

const DynamicBarChart = ({ data, xField, yField, title, isMaximized }) => {
  const config = {
    data,
    xField,
    yField,
    autoFit: true,
    height: isMaximized ? 500 : 200,
    // height: 140, // ✅ chart height
    label: false,
    // label: {
    //   position: "middle",
    //   style: {
    //     fill: "#FFFFFF",
    //     opacity: 0.6,
    //   },
    //   formatter: (datum) => {
    //     // Some versions pass datum object, some pass value directly
    //     const value =
    //       typeof datum === "object" && datum[yField] !== undefined
    //         ? datum[yField]
    //         : datum;
    //     const num = Number(value);
    //     return isNaN(num) ? "" : num.toFixed(2);
    //   },
    // },
    scrollbar: {
      type: "vertical",
    },
    meta: {
      [xField]: { alias: xField },
      [yField]: { alias: yField },
    },
  };

  return (
    <div className="my-4" style={{ width: "95%", height: "70%" }}>
      {title && <h3 className="text-center mb-2">{title}</h3>}
      <Bar {...config} />
    </div>
  );
};

export default DynamicBarChart;
